const orderPl = {
    "total": "Całkowity",
    "order_successfully_placed": "Zamówienie złożone",
    "empty_cart": "Twój koszyk jest obecnie pusty",
    "place_order": "Złóż zamówienie",
    "i_order": "Złóż zamówienie",
    "order_confirmation": "Potwierdzenie zamówienia",
    "order_confirmation_msg_raw": "Składając zamówienie, akceptujesz nasze warunki korzystania i naszą politykę prywatności, które znajdziesz w <a href=\":link\" class=\"generated-link\" target=\"_blank\">linku poniżej</a>.",
    "status_PLACED": "Umieszczony",
    "status_ACCEPTED": "Przyjęty",
    "status_SERVED": "Podano",
    "status_PAID": "Płatny",
    "empty_pending_orders": "W tej chwili nie masz żadnych oczekujących zamówień",
    "overview": "Przegląd zamówień",
    "note": "Notatka",
    "items": "Rzeczy",
    "review_order": "Przegląd"
};

export default orderPl;
